import React from "react";
import { Link, useLocation, Navigate } from "react-router-dom";
import { CheckCircle2 } from "lucide-react";

const formatPhone = (v = "") => {
  const m = v.replace(/\D/g, "").match(/^1?(\d{3})(\d{3})(\d{4})$/);
  return m ? `(${m[1]}) ${m[2]}-${m[3]}` : v;
};

const OrderSuccess = () => {
  const loc = useLocation();
  const order = loc.state?.order;
  if (!order) return <Navigate to="/" replace />;

  return (
    <div className="max-w-md mx-auto px-4 pt-24 pb-24 text-center">
      <CheckCircle2 className="h-16 w-16 text-[#2c6e49] mx-auto mb-4" />
      <h1 className="font-heading text-3xl font-bold text-[#2c1e12]">Order confirmed!</h1>
      <p className="text-[#8a7458] mt-1">Your order number is</p>
      <p className="font-heading text-2xl font-bold text-[#9a4a2f] mt-1">{order.order_number}</p>

      <div className="mt-5 rounded-2xl bg-[#f6ece0] p-4 text-left">
        <p className="text-sm text-[#6b5844]">{order.fulfillment_type === "delivery" ? "Delivery" : "Pickup"} on <strong>{order.fulfillment_date}</strong></p>
        <div className="mt-3 space-y-1">
          {order.items.map((it, i) => (
            <div key={i} className="flex justify-between text-sm text-[#2c1e12]">
              <span>{it.qty} × {it.name}</span>
              <span>${(it.price * it.qty).toFixed(2)}</span>
            </div>
          ))}
        </div>
        <div className="border-t border-[#e6d8bf] mt-3 pt-3 space-y-1 text-sm text-[#6b5844]">
          <div className="flex justify-between"><span>Subtotal</span><span>${order.subtotal.toFixed(2)}</span></div>
          {order.discount > 0 && <div className="flex justify-between text-[#2c6e49]"><span>Reward discount</span><span>-${order.discount.toFixed(2)}</span></div>}
          {order.coupon_discount > 0 && <div data-testid="success-coupon-discount" className="flex justify-between text-[#2c6e49]"><span>Coupon ({order.coupon_code})</span><span>-${order.coupon_discount.toFixed(2)}</span></div>}
          <div className="flex justify-between"><span>Tax (7%)</span><span>${order.tax.toFixed(2)}</span></div>
        </div>
        <div className="mt-2 flex justify-between font-bold text-[#2c1e12]">
          <span>Total</span><span>${order.total.toFixed(2)}</span>
        </div>
        {order.points_earned > 0 && <p className="text-sm text-[#2c6e49] mt-2">You earned {order.points_earned} reward points!</p>}
      </div>

      <div data-testid="zelle-instructions" className="mt-4 rounded-2xl bg-[#f7e4df] p-4 text-left text-sm text-[#2c1e12]">
        <p className="font-semibold">How to pay</p>
        <p className="mt-1 text-[#6b5844]">Send <strong>${order.total.toFixed(2)}</strong> via Zelle to <strong>{formatPhone(order.zelle_recipient)}</strong> with order number <strong>{order.order_number}</strong> in the memo.</p>
      </div>

      <p className="text-sm text-[#8a7458] mt-4">A confirmation email is on its way to you.</p>
      <Link to="/menu" className="mt-5 inline-flex rounded-xl bg-[#9a4a2f] hover:bg-[#853e26] text-white font-semibold px-6 py-3 transition-colors">Order More</Link>
    </div>
  );
};

export default OrderSuccess;
